import PageTitle from "../components/PageTitle";
import { BsRecordFill, BsZoomIn, BsHeart } from "react-icons/bs";
import { CiShoppingCart } from "react-icons/ci";
import Collaboration from "../components/Collaboration";
import ShopFilter from "../components/ShopFilter";

export default function ShopGrid() {
  return (
    <>
      <PageTitle title="Shop Grid Default" path={["Pages ", "Shop Grid"]} />
      <ShopFilter />
      {/* grid */}
      <div className="max-w-5xl mx-auto grid grid-cols-4 gap-y-6 ">
        {/* card */}
        <Card
          name="Vel elit euismod"
          img={require("../assets/shop-grid/img01.png")}
        />
        <Card
          name="Ultericies condimentum impredient"
          img={require("../assets/shop-grid/img02.png")}
        />
        <Card
          name="Vite Suspendisse sed"
          img={require("../assets/shop-grid/img03.png")}
        />
        <Card
          name="Sed at fermentum"
          img={require("../assets/shop-grid/img04.png")}
        />
        <Card
          name="Vestibulum mangna loareet"
          img={require("../assets/shop-grid/img05.png")}
        />
        <Card
          name="Ultricesmauris sit"
          img={require("../assets/shop-grid/img06.png")}
        />
        <Card
          name="Vel elit euismod"
          img={require("../assets/shop-grid/img07.png")}
        />
        <Card
          name="Ultericies condimentum impredient"
          img={require("../assets/shop-grid/img08.png")}
        />
        <Card
          name="Vite Suspendisse sed"
          img={require("../assets/shop-grid/img09.png")}
        />
        <Card
          name="Sed at fermentum"
          img={require("../assets/shop-grid/img10.png")}
        />
        <Card
          name="Vestibulum mangna loareet"
          img={require("../assets/shop-grid/img11.png")}
        />
        <Card
          name="Ultricesmauris sit"
          img={require("../assets/shop-grid/img12.png")}
        />
      </div>
      <Collaboration />
    </>
  );
}

function Card({ img, name, price }) {
  return (
    <>
      <div className=" mx-auto w-60 group">
        {/* image container */}
        <div className="h-60 relative overflow-hidden bg-[#F6F7FB] group-hover:bg-[#EBF4F3] mb-4 flex items-center justify-center">
          <div className="absolute top-0 left-0 right-0 bottom-0 hidden group-hover:flex flex-col justify-end pl-2 pb-3 items-start">
            <div className="p-2 cursor-pointer rounded-full hover:bg-white">
              <CiShoppingCart size={20} />
            </div>
            <div className="p-2 cursor-pointer ml-1 my-1 rounded-full hover:bg-white">
              <BsHeart size={15} />
            </div>
            <div className="p-2 cursor-pointer ml-1 rounded-full hover:bg-white">
              <BsZoomIn size={15} />
            </div>
          </div>
          <img alt="" src={img} />
        </div>
        {/* text container */}
        <div className="text-center font-fontOne">
          <h4 className="text-lg font-semibold">{name}</h4>
          {/* colors */}
          <div className="flex my-2 justify-center">
            <BsRecordFill color="#8568FF" />
            <BsRecordFill color="#DE9034" />
            <BsRecordFill color="#EC42A2" />
          </div>
          {/* price */}
          <p className=" text-sm">
            <spa>$26.00</spa>&nbsp;
            <spa className=" line-through text-pink">$42.00</spa>
          </p>
        </div>
      </div>
    </>
  );
}
